<template>
  <div class="back">
    <img
      style="width: 100%"
      src="../../assets/img/0a9bc2732006ad4684283751731da95.jpg"
      alt=""
    />
    <div
      style="
        position: absolute;
        left: 2rem;
        top: 10rem;
        right: 2rem;
        text-align: center;
      "
    >
      <div style="height: 3rem; overflow: hidden">
        <div style="color: #666; font-size: 0.35rem; margin-top: 0.6rem">
          累计批卡数(张)
        </div>
        <div style="font-size: 0.8rem; font-weight: 900; margin-top: 0.4rem">
          {{ data.rtsCount }}
        </div>
      </div>
      <div style="height: 3rem; overflow: hidden">
        <div style="color: #666; font-size: 0.35rem; margin-top: 0.6rem">
          累计获得奖励(元)
        </div>
        <div style="font-size: 0.8rem; font-weight: 900; margin-top: 0.4rem">
          {{ (data.rtsCommission / 100).toFixed(2) }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { api } from "../../biz/api";
import Vue from "vue";

export default {
  data() {
    return {
      data: {},
    };
  },
  mounted() {
    api.GetActivityInfo(this.$route.query.id).then((res) => {
      this.data = res.body.data;
    });
  },
  methods: {},
};
</script>

<style lang="less">
.back {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background-color: #340606;
  overflow: auto;
  font-size: 0.4rem;
}
</style>

